import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getPageContent } from "../../utils";
import { selectAnswerData, selectAnswerStatus, selectAnswerError, initializeAsync } from "./answerSlice";

import { useAuth } from "../../hooks/useAuth";
import { Logo } from "../../components/Logo";
import {
    Button,
    CssBaseline,
    TextField,
    Box,
    Typography,
    Container,
    Paper,
    Snackbar,
    Alert,
    Tabs,
    Tab,
} from "@mui/material";

import LoadingButton from "@mui/lab/LoadingButton";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import { MuiOtpInput } from "mui-one-time-password-input";
import OTPInput from "./OTPInputs";
import { useMediaQuery } from "react-responsive";
import { post } from "../../api";

const Answer = () => {
    const data = useSelector(selectAnswerData);
    const status = useSelector(selectAnswerStatus);
    const error = useSelector(selectAnswerError);
    const dispatch = useDispatch();
    const { answer, user, isAuthenticated, passwordLessLogin } = useAuth();
    const [openToster, setOpenToster] = useState(false);
    const [tosterVariant, setTosterVariant] = useState("error");
    const [tosterMessage, setTosterMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    if (!location.state) {
        navigate("/login", {
            replace: true,
        });
    }
    let displayEmail = false;
    if (location.state) {
        if (!location.state?.contactData.phone || location.state?.contactData.preferredMediumToVerify === "Email") {
            displayEmail = true;
        }
    }

    const [selectedVerifyThrough, setSelectedVerifyThrough] = React.useState(displayEmail ? 1 : 0);
    const [alreadyOTPSent, setAlreadyOTPSent] = React.useState(displayEmail ? "Email" : "Phone");
    const [otp, setOtp] = React.useState("");
    const [timeLeft, setTimeLeft] = useState(60);
    console.log("State ", location.state);
    const [isResendAvailable, setIsResendAvailable] = useState(false);
    const [onlyEmail, setOnlyEmail] = useState(location.state?.contactData?.phone ? false : true);
    const isDesktop = useMediaQuery({ minWidth: 1180 });
    useEffect(() => {
        // Timer countdown logic
        if (timeLeft > 0) {
            setIsResendAvailable(false);
            const timerId = setInterval(() => {
                setTimeLeft(timeLeft - 1);
            }, 1000);
            return () => clearInterval(timerId); // Cleanup the interval on component unmount
        } else {
            setIsResendAvailable(true); // Allow resend when timer reaches 0
        }
    }, [timeLeft]);
    useEffect(() => {
        if (status === "idle") {
            dispatch(initializeAsync());
        }
    }, [status, dispatch]);

    if (!user || !user.sendCustomChallengeAnswer) {
        navigate("/login", {
            replace: true,
        });
    }

    const handleTosterClose = () => {
        setOpenToster(false);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        const data = new FormData(event.currentTarget);
        let authenticated = await isAuthenticated();
        if (authenticated) {
            window.location.href = "/";
            return;
        }
        if (otp) {
            answer(user, otp, (message) => {
                message = message ? message : "Invalid otp";
                if (message) {
                    setTosterVariant("error");
                    setTosterMessage(message);
                    setOpenToster(true);
                }
                setLoading(false);
            });
        }
    };

    const handleVerifyThroughChange = (event, newValue) => {
        setSelectedVerifyThrough(newValue);
        // setTimeLeft(60);
        // setAlreadyOTPSent(newValue === 1 ? "Email" : "Phone");
        // post(`lead/updateLeadPreferred`, {
        //     contactData: location.state?.contactData,
        //     preferredValue: newValue === 1 ? "Email" : "Phone",
        // }).then(async (result) => {
        //     setTosterVariant("success");
        //     setTosterMessage(`Successfully sent OTP to your ${newValue === 1 ? "email" : "phone"}`);
        //     setOpenToster(true);
        //     passwordLessLogin({
        //         email: location.state?.contactData.email,
        //         contactData: location.state?.contactData,
        //         callback: (failed) => {
        //             if (failed) {
        //                 setTosterVariant("error");
        //                 setTosterMessage(`Sorry, we don't recognize this email address`);
        //                 setOpenToster(true);
        //             }
        //             setLoading(false);
        //         },
        //     });
        // });
    };

    const sendOTP = () => {
        setTimeLeft(60);
        setAlreadyOTPSent(selectedVerifyThrough === 1 ? "Email" : "Phone");
        post(`lead/updateLeadPreferred`, {
            contactData: location.state?.contactData,
            preferredValue: selectedVerifyThrough === 1 ? "Email" : "Phone",
        }).then(async (result) => {
            setTosterVariant("success");
            setTosterMessage(`Successfully sent OTP to your ${selectedVerifyThrough === 1 ? "email" : "phone"}`);
            setOpenToster(true);
            passwordLessLogin({
                email: location.state?.contactData.email,
                contactData: location.state?.contactData,
                callback: (failed) => {
                    if (failed) {
                        setTosterVariant("error");
                        setTosterMessage(`Sorry, we don't recognize this email address`);
                        setOpenToster(true);
                    }
                    setLoading(false);
                },
            });
        });
    };

    const handleResend = () => {
        setTosterVariant("success");
        setTosterMessage(`Successfully resent OTP to your ${selectedVerifyThrough === 1 ? "email" : "phone"}`);
        setOpenToster(true);
        passwordLessLogin({
            email: location.state?.contactData.email,
            contactData: location.state?.contactData,
            callback: (failed) => {
                if (failed) {
                    setTosterVariant("error");
                    setTosterMessage(`Sorry, we don't recognize this email address`);
                    setOpenToster(true);
                }
                setLoading(false);
            },
        });
        setTimeLeft(60);
    };

    const handleChange = (otp) => {
        setOtp(otp);
    };

    const getMaskedPhone = () => {
        const cleanedStr = location.state?.contactData?.phone.replace(/\D/g, ""); // Remove any non-digit characters
        const lastFourDigits = cleanedStr.slice(-4);
        return `+1 XXX XXX ${lastFourDigits}`;
    };

    const formatTime = (seconds) => {
        return `00:${seconds < 10 ? "0" : ""}${seconds}`; // Ensures "00:SS" format
    };

    const maskEmail = (email) => {
        const [name, domain] = location.state?.contactData?.email.split("@");
        const maskedName = name.slice(0, 2) + "****" + name.slice(-2);
        return `${maskedName}@${domain}`;
    };

    const isMethodChanged = () => {
        if (alreadyOTPSent !== (selectedVerifyThrough === 1 ? "Email" : "Phone")) {
            return true;
        }
        return false;
    };

    let body = (
        <Box
            component="main"
            sx={{
                position: "absolute",
                width: "100%",
                height: "100%",
                backgroundColor: "#ffffff",
            }}>
            <Box
                sx={{
                    alignItems: "center",
                    display: "flex",
                    flexGrow: 1,
                    minHeight: "100%",
                }}>
                <Container maxWidth="sm">
                    <CssBaseline />
                    <Paper
                        elevation={16}
                        sx={{
                            backgroundColor: "rgb(255, 255, 255)",
                            color: "rgb(18, 24, 40)",
                            transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                            borderRadius: "8px",
                            boxShadow: "rgb(100 116 139 / 12%) 0px 10px 15px",
                            backgroundImage: "none",
                            overflow: "hidden",
                            padding: "32px",
                        }}>
                        {!onlyEmail && (
                            <Tabs
                                value={selectedVerifyThrough}
                                onChange={handleVerifyThroughChange}
                                aria-label="icon label tabs example"
                                centered
                                sx={{ mb: "1.5rem" }}>
                                <Tab
                                    icon={<PhoneIcon />}
                                    sx={{ fontSize: isDesktop ? "auto" : "0.70rem" }}
                                    label="Verify through Phone"
                                    iconPosition={isDesktop ? "start" : "top"}
                                />
                                <Tab
                                    icon={<EmailIcon />}
                                    sx={{ fontSize: isDesktop ? "auto" : "0.70rem" }}
                                    label="Verify through Email"
                                    iconPosition={isDesktop ? "start" : "top"}
                                />
                            </Tabs>
                        )}
                        {isMethodChanged() && (
                            <Box>
                                <Box>
                                    <Box sx={{ textAlign: "center" }}>
                                        <Typography component="h1" variant="h4" sx={{ fontSize: "1.5rem" }}>
                                            <p>Verify your</p>
                                            login details through {selectedVerifyThrough === 1 ? "email" : "phone"}
                                        </Typography>
                                        <Typography
                                            align="center"
                                            color="textSecondary"
                                            variant="body1"
                                            marginTop="1rem"
                                            fontSize="0.875rem">
                                            Send one-time-passcode to{" "}
                                            {selectedVerifyThrough === 0 && !onlyEmail ? getMaskedPhone() : maskEmail()}
                                        </Typography>
                                    </Box>
                                    <LoadingButton
                                        size="small"
                                        type="submit"
                                        color="primary"
                                        onClick={sendOTP}
                                        fullWidth
                                        loading={loading}
                                        loadingPosition="end"
                                        sx={{
                                            mt: 3,
                                            mb: 2,
                                            height: "45px",
                                            background: "white",
                                            color: "#06AED4",
                                            border: "2px solid #06AED4",
                                        }}>
                                        Send Code
                                    </LoadingButton>
                                </Box>
                            </Box>
                        )}
                        {!isMethodChanged() && (
                            <Box>
                                <Box sx={{ textAlign: "center" }}>
                                    <Typography component="h1" variant="h4" sx={{ fontSize: "1.5rem" }}>
                                        Please enter One-Time Passcode to verify your details
                                    </Typography>
                                    <Typography
                                        align="center"
                                        color="textSecondary"
                                        variant="body1"
                                        marginTop="1rem"
                                        fontSize="0.875rem">
                                        We've sent a one-time-passcode to{" "}
                                        {selectedVerifyThrough === 0 && !onlyEmail ? getMaskedPhone() : maskEmail()}
                                    </Typography>
                                </Box>
                                <Box component="form" onSubmit={handleSubmit} validate sx={{ mt: 1 }}>
                                    <Box sx={{ mb: "1rem", mt: "1.5rem", display: "flex", justifyContent: "center" }}>
                                        <OTPInput onChange={handleChange}></OTPInput>
                                    </Box>

                                    <LoadingButton
                                        size="small"
                                        type="submit"
                                        color="primary"
                                        fullWidth
                                        loading={loading}
                                        loadingPosition="end"
                                        variant="contained"
                                        sx={{ mt: 3, mb: 2, height: "45px" }}>
                                        Submit
                                    </LoadingButton>
                                </Box>
                                <Box sx={{ textAlign: "center" }}>
                                    <Typography
                                        sx={{ fontSize: "14px" }}
                                        align="center"
                                        color="textSecondary"
                                        variant="body1"
                                        marginTop="1rem"
                                        fontSize="0.875rem">
                                        Didn’t receive the code?{" "}
                                        {isResendAvailable ? (
                                            <Button
                                                sx={{ padding: "5px 5px", marginTop: "-2px" }}
                                                onClick={handleResend}>
                                                Resend Code
                                            </Button>
                                        ) : (
                                            <span>
                                                Resend in{" "}
                                                <span
                                                    style={{
                                                        minWidth: "45px",
                                                        display: "inline-block",
                                                        textAlign: "left",
                                                    }}>
                                                    {formatTime(timeLeft)}
                                                </span>{" "}
                                            </span>
                                        )}
                                    </Typography>
                                </Box>
                            </Box>
                        )}
                    </Paper>
                </Container>
            </Box>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={openToster}
                autoHideDuration={6000}
                onClose={handleTosterClose}>
                <Alert onClose={handleTosterClose} severity={tosterVariant} variant="filled">
                    {tosterMessage}
                </Alert>
            </Snackbar>
        </Box>
    );

    return getPageContent(body, status, error);
};

export { Answer };
